import React, { memo } from "react";
import useQrCodePage from "./index.hooks";
import AppPaper from "components/AppPaper";
import AppFilterableSelect from "components/AppFilterableSelect";
import AppButton from "components/AppButton";
import {
  Typography,
  Collapse,
  Paper,
  Box,
  Grid,
  CircularProgress,
} from "@material-ui/core";
import PhotoCameraIcon from "@material-ui/icons/PhotoCamera";
import { QrReader } from "react-qr-reader";
import cn from "classnames";

type QrCodePageProps = {};

const QrCodePage = ({}: QrCodePageProps) => {
  const {
    styles,
    classes,
    atomicStyles,
    t,
    options,
    handleSelection,
    selectedEventId,
    selectedEventTitle,
    scannerOpen,
    openScanner,
    qrUuid,
    onScannedData,
    constraints,
    singleUseEvent,
    onConsumeSingleUseEvent,
    onRemoveQrUuid,
    isCheckingQrCode,
    isConsumingQrCode,
  } = useQrCodePage();

  return (
    <AppPaper>
      <Typography variant="h4" color="primary" className={styles.title}>
        {t("Verifica codice QR")}
      </Typography>
      <AppFilterableSelect
        searchValue={selectedEventTitle}
        className={styles.searchBar}
        fullWidth
        options={options}
        placeholder={t("Cerca tra i tuoi eventi con codice QR di attivazione")}
        inputClassName={styles.inputProps}
        dropdownClassName={styles.dropDown}
        onItemSelected={handleSelection}
      />
      {selectedEventId !== null && (
        <>
          {!qrUuid && !scannerOpen && (
            <AppButton
              className={styles.scanButton}
              variant="contained"
              color="primary"
              onClick={openScanner}
              startIcon={<PhotoCameraIcon />}
            >
              Scan QRcode
            </AppButton>
          )}
          {scannerOpen && (
            <QrReader
              className={styles.scanner}
              constraints={constraints}
              onResult={onScannedData}
              scanDelay={300}
            />
          )}
          {isCheckingQrCode && (
            <Box
              className={cn(
                atomicStyles.DF,
                atomicStyles.MT20,
                atomicStyles.AIC,
                atomicStyles.JCC,
              )}
            >
              <Typography>Codice trovato! Verifica in corso...</Typography>
              <CircularProgress className={atomicStyles.ML20} />
            </Box>
          )}
          {singleUseEvent !== null ? (
            singleUseEvent.hasBeenUsed ? (
              <Box>
                <AppButton
                  color="primary"
                  variant="contained"
                  onClick={onRemoveQrUuid}
                >
                  Ricomincia
                </AppButton>
              </Box>
            ) : isConsumingQrCode ? (
              <Box
                className={cn(
                  atomicStyles.DF,
                  atomicStyles.MT20,
                  atomicStyles.AIC,
                  atomicStyles.JCC,
                )}
              >
                <Typography>Consumo della promozione in corso...</Typography>
                <CircularProgress className={atomicStyles.ML20} />
              </Box>
            ) : (
              <Box className={styles.consumeButton}>
                <AppButton
                  isCta
                  variant="contained"
                  onClick={onConsumeSingleUseEvent}
                >
                  Consuma il codice QR
                </AppButton>
              </Box>
            )
          ) : null}
        </>
      )}
    </AppPaper>
  );
};

export default memo(QrCodePage);
